import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";

import {
  buttonDeleteAccount,
  labelDeleteAccount,
  labelProfileDeleteAccount,
} from "_constants";
import { ModalDeleteAccount } from "components/modals";

import { useState } from "react";

export const DeleteAccountContainer = () => {
  const [showModal, setShowModal] = useState(false);

  const openDeleteAccountModal = () => {
    setShowModal(true);
  };

  return (
    <>
      <div className="flex-container column gap-8">
        <span className="text-base-bold">
          {labelDeleteAccount.toUpperCase()}
        </span>
        <span className="text-base-regular">{labelProfileDeleteAccount}</span>
        <Button
          label={buttonDeleteAccount}
          icon={PrimeIcons.TRASH}
          onClick={openDeleteAccountModal}
          severity="danger"
          outlined
          className="margin-top-10 button-delete-account"
        />
      </div>
      <ModalDeleteAccount
        showModal={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};
